import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toState1lqvgl5d0bogr as toState } from '../CompletionState.mjs';
import { ThreadLocalEventLoop_getInstancenusaemxxykog as ThreadLocalEventLoop_getInstance } from '../EventLoop.common.mjs';
import { Key_instancebefxze3q9f64 as Key_instance } from '../Job.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../CancellableContinuationImpl.mjs';
import {
  DispatchedTask39ez3ayqqzt3m as DispatchedTask,
  DispatchException248dwsudeuh1h as DispatchException,
} from '../DispatchedTask.mjs';
import { threadContextElements12yd4mfmaodla as threadContextElements } from './ThreadContext.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { toDebugString2sjrkc0z7k0mx as toDebugString } from '../CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './Symbol.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_UNDEFINED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return UNDEFINED;
}
var UNDEFINED;
function get_REUSABLE_CLAIMED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return REUSABLE_CLAIMED;
}
var REUSABLE_CLAIMED;
function resumeCancellableWithInternal(_this__u8e3s4, result) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp;
  if (_this__u8e3s4 instanceof DispatchedContinuation()) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith' call
    var state = toState(result);
    if (safeIsDispatchNeeded(_this__u8e3s4.uz_1, _this__u8e3s4.pc())) {
      _this__u8e3s4.wz_1 = state;
      _this__u8e3s4.d10_1 = 1;
      safeDispatch(_this__u8e3s4.uz_1, _this__u8e3s4.pc(), _this__u8e3s4);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().b14();
        if (false && eventLoop.w13()) {
          break $l$block;
        }
        var tmp_0;
        if (eventLoop.v13()) {
          _this__u8e3s4.wz_1 = state;
          _this__u8e3s4.d10_1 = 1;
          eventLoop.u13(_this__u8e3s4);
          tmp_0 = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.x13(true);
          try {
            var tmp$ret$5;
            $l$block_0: {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
              var job = _this__u8e3s4.pc().bd(Key_instance);
              if (!(job == null) && !job.cw()) {
                var cause = job.bx();
                _this__u8e3s4.b11(state, cause);
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(cause));
                _this__u8e3s4.rc(tmp$ret$7);
                tmp$ret$5 = true;
                break $l$block_0;
              }
              tmp$ret$5 = false;
            }
            if (!tmp$ret$5) {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
              _this__u8e3s4.vz_1;
              // Inline function 'kotlinx.coroutines.withContinuationContext' call
              _this__u8e3s4.xz_1;
              _this__u8e3s4.vz_1.rc(result);
            }
            $l$loop: while (eventLoop.t13()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              _this__u8e3s4.v11(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.y13(true);
          }
          tmp_0 = false;
        }
      }
    }
    tmp = Unit_instance;
  } else {
    _this__u8e3s4.rc(result);
    tmp = Unit_instance;
  }
  return tmp;
}
function _get_reusableCancellableContinuation__9qex09($this) {
  var tmp = $this.yz_1.kotlinx$atomicfu$value;
  return tmp instanceof CancellableContinuationImpl() ? tmp : null;
}
var DispatchedContinuationClass;
function DispatchedContinuation() {
  if (DispatchedContinuationClass === VOID) {
    class $ extends DispatchedTask() {
      constructor(dispatcher, continuation) {
        super(-1);
        this.uz_1 = dispatcher;
        this.vz_1 = continuation;
        this.wz_1 = get_UNDEFINED();
        this.xz_1 = threadContextElements(this.pc());
        this.yz_1 = atomic$ref$1(null);
      }
      c10() {
        return !(this.yz_1.kotlinx$atomicfu$value == null);
      }
      y1h() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.yz_1;
        while (true) {
          if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
            return Unit_instance;
        }
      }
      z12() {
        this.y1h();
        var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.x10();
        }
      }
      zz() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.yz_1;
        while (true) {
          var state = this_0.kotlinx$atomicfu$value;
          if (state === null) {
            this.yz_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
            return null;
          } else {
            if (state instanceof CancellableContinuationImpl()) {
              if (this.yz_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
                return state instanceof CancellableContinuationImpl() ? state : THROW_CCE();
              }
            } else {
              if (state !== get_REUSABLE_CLAIMED()) {
                if (!(state instanceof Error)) {
                  // Inline function 'kotlin.error' call
                  var message = 'Inconsistent state ' + toString(state);
                  throw IllegalStateException().o(toString(message));
                }
              }
            }
          }
        }
      }
      j11(continuation) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.yz_1;
        while (true) {
          var state = this_0.kotlinx$atomicfu$value;
          if (state === get_REUSABLE_CLAIMED()) {
            if (this.yz_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
              return null;
          } else {
            if (state instanceof Error) {
              // Inline function 'kotlin.require' call
              // Inline function 'kotlin.require' call
              if (!this.yz_1.atomicfu$compareAndSet(state, null)) {
                var message = 'Failed requirement.';
                throw IllegalArgumentException().n2(toString(message));
              }
              return state;
            } else {
              // Inline function 'kotlin.error' call
              var message_0 = 'Inconsistent state ' + toString_0(state);
              throw IllegalStateException().o(toString(message_0));
            }
          }
        }
      }
      e10(cause) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.yz_1;
        while (true) {
          var state = this_0.kotlinx$atomicfu$value;
          if (equals(state, get_REUSABLE_CLAIMED())) {
            if (this.yz_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
              return true;
          } else {
            if (state instanceof Error)
              return true;
            else {
              if (this.yz_1.atomicfu$compareAndSet(state, null))
                return false;
            }
          }
        }
      }
      a11() {
        var state = this.wz_1;
        // Inline function 'kotlinx.coroutines.assert' call
        this.wz_1 = get_UNDEFINED();
        return state;
      }
      y10() {
        return this;
      }
      rc(result) {
        var state = toState(result);
        if (safeIsDispatchNeeded(this.uz_1, this.pc())) {
          this.wz_1 = state;
          this.d10_1 = 0;
          safeDispatch(this.uz_1, this.pc(), this);
        } else {
          $l$block: {
            // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
            // Inline function 'kotlinx.coroutines.assert' call
            var eventLoop = ThreadLocalEventLoop_getInstance().b14();
            if (false && eventLoop.w13()) {
              break $l$block;
            }
            var tmp;
            if (eventLoop.v13()) {
              this.wz_1 = state;
              this.d10_1 = 0;
              eventLoop.u13(this);
              tmp = true;
            } else {
              // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
              eventLoop.x13(true);
              try {
                this.pc();
                // Inline function 'kotlinx.coroutines.withCoroutineContext' call
                this.xz_1;
                this.vz_1.rc(result);
                $l$loop: while (eventLoop.t13()) {
                }
              } catch ($p) {
                if ($p instanceof Error) {
                  var e = $p;
                  this.v11(e);
                } else {
                  throw $p;
                }
              }
              finally {
                eventLoop.y13(true);
              }
              tmp = false;
            }
          }
        }
      }
      toString() {
        return 'DispatchedContinuation[' + this.uz_1.toString() + ', ' + toDebugString(this.vz_1) + ']';
      }
      pc() {
        return this.vz_1.pc();
      }
    }
    initMetadataForClass($, 'DispatchedContinuation', VOID, VOID, [Continuation()]);
    DispatchedContinuationClass = $;
  }
  return DispatchedContinuationClass;
}
function safeDispatch(_this__u8e3s4, context, runnable) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    _this__u8e3s4.y12(context, runnable);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw DispatchException().z1h(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function safeIsDispatchNeeded(_this__u8e3s4, context) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    return _this__u8e3s4.v12(context);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw DispatchException().z1h(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
var properties_initialized_DispatchedContinuation_kt_2siadq;
function _init_properties_DispatchedContinuation_kt__tnmqc0() {
  if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
    properties_initialized_DispatchedContinuation_kt_2siadq = true;
    UNDEFINED = new (Symbol())('UNDEFINED');
    REUSABLE_CLAIMED = new (Symbol())('REUSABLE_CLAIMED');
  }
}
//region block: exports
export {
  DispatchedContinuation as DispatchedContinuation8kf77e5g2ha2,
  resumeCancellableWithInternal as resumeCancellableWithInternalk8vmvm2je8v0,
  safeDispatch as safeDispatch2vco9v5u7w5xs,
  safeIsDispatchNeeded as safeIsDispatchNeeded2sl03dqd165wc,
};
//endregion

//# sourceMappingURL=DispatchedContinuation.mjs.map
